/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./GivingLeague.css";

// Business · "peers". A public ranking is what makes a business raise its
// rate, so every row opens into how the business ahead of you does it.
class GivingLeague extends Component {
  render() {
    const vm = this.props.vm;
    const b = vm.board;
    return (
      <div className="Marketplace-card Marketplace-League">
        <div className="Marketplace-cardHead">
          <span className="Marketplace-cardTitle">{vm.m.boardTitle}</span>
          <div className="Marketplace-chipRow">
            {b.chips.map((c) => (
              <div
                className={"Marketplace-chip" + (c.active ? " Marketplace-chip--active" : "")}
                onClick={c.pick}
                key={c.id || "all"}
              >
                {c.label}
              </div>
            ))}
          </div>
        </div>
        {b.rows.map((r) => (
          <div className="Marketplace-League-block" key={r.id}>
            <div
              className={"Marketplace-League-row" + (r.open ? " Marketplace-League-row--open" : "")}
              onClick={r.toggle}
            >
              <span className="Marketplace-League-rank" style={{ color: r.rankColor }}>
                {r.rank}
              </span>
              <div className="Marketplace-League-biz">
                <div className="Marketplace-mono">{r.mono}</div>
                <div>
                  <div className="Marketplace-League-name">{r.name}</div>
                  <div className="Marketplace-League-meta">
                    {r.industry} · {r.district}
                  </div>
                </div>
              </div>
              <div>
                <span className="Marketplace-ruleChip">{r.rule}</span>
              </div>
              <span className="Marketplace-right Marketplace-League-given">{r.givenLabel}</span>
              <span className="Marketplace-right Marketplace-League-causes">{r.causes}</span>
              <span className="Marketplace-right Marketplace-League-more">{r.moreLabel}</span>
            </div>
            {r.open && (
              <div className="Marketplace-League-detail Marketplace-animIn">
                <div>
                  <div className="Marketplace-cardTitle">{vm.m.boardSupports}</div>
                  <div className="Marketplace-League-supports">
                    {r.supportRows.map((s) => (
                      <div className="Marketplace-League-support" key={s.id}>
                        <span className="Marketplace-League-supportName">{s.name}</span>
                        <span className="Marketplace-League-supportShare">{s.share}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <div className="Marketplace-cardTitle">{vm.m.boardByMonth}</div>
                  <div className="Marketplace-League-spark">
                    {r.spark.map((s) => (
                      <div className="Marketplace-League-sparkBar" style={{ height: s.h }} key={s.id} />
                    ))}
                  </div>
                  <div className="Marketplace-League-since">{r.sinceLine}</div>
                </div>
                <div>
                  <div className="Marketplace-cardTitle">{vm.m.boardHow}</div>
                  <div className="Marketplace-League-note">{r.note}</div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

GivingLeague.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default GivingLeague;
